import * as Yup from "yup";

export const LegalEntityAddFormValidation = Yup.object({
  name: Yup.string().required("بانک را انتخاب نمایید"),
});
